import { MinzeAttrs, MinzeElement } from 'minze'
import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'lvcRecommended', {
  label: 'Recommandé par:',
})
Locale.getInstance().registerKeySet('en', 'lvcRecommended', {
  label: 'Recommended by:',
})
export interface LvcRecommendation {
  name: string
  image: string | null
}
export interface LvcRecommended {
  recommendedList: string
}
export class LvcRecommended extends MinzeElement {
  attrs: MinzeAttrs = [['recommended-list', '']]
  static observedAttributes = ['recommended-list']
  html = () => {
    const parsedData: LvcRecommendation[] = JSON.parse(decodeURIComponent(this.recommendedList))
    if (!parsedData || parsedData.length < 1) return ''
    return `
    <div class="recommended-by-wrapper">
      <div class="recommended-by-label">${Locale.getKey('lvcRecommended.label')}</div>
      <div class="recommended-by-item-wrapper">
      ${parsedData
        .map(
          item => `
        <div class="recommended-by-item">
          <img
            class="recommended-by-image"
            width="32"
            height="32"
            src="${item.image ?? `https://cloud.squidex.io/api/assets/lvc-dev/64048829-12e1-484f-a399-f530500c261c/lvc-avatar-placeholder.svg?version=0`}"/>
          <div>${item.name}</div>
        </div>
      `
        )
        .join('')}
      </div>
    </div>
    `
  }
  css = () => `
    :host {
      font-weight: 800;
      font-size: 12px;
    }
    .recommended-by-wrapper {
      display: flex;
      align-items: center;
      gap: 1rem;
    }
    .recommended-by-item-wrapper {
      display: flex;
      gap: 1rem;
    }
    .recommended-by-item {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .recommended-by-image {
      border-radius: 50%;
      background-color: rgba(255,255,255,0.5);
    }
    @media screen and (max-width: 991px) {
      .recommended-by-wrapper {
        align-items: flex-start;
        flex-direction: column;
        gap: 0.5rem;
      }
      .recommended-by-item-wrapper {
        align-items: flex-start;
        flex-direction: column;
        gap: 0.5rem;
      }
    }
  `
}
